import type { ReactNode } from 'react'
import loginLogo from '~/assets/logos/logoSoft.svg'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/components/ui/card'
import { cn } from '~/lib/utils'

/**
 * Cadre des écrans hors session (connexion, mot de passe oublié, étape « code », enrôlement
 * obligatoire) : carte centrée, logo, titre et description.
 */
export function AuthCard({
  title,
  description,
  className,
  contentClassName,
  children,
}: {
  title: ReactNode
  description?: ReactNode
  /** Largeur de la carte, `max-w-sm` par défaut. */
  className?: string
  contentClassName?: string
  children: ReactNode
}) {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className={cn('w-full max-w-sm', className)}>
        <CardHeader className="justify-items-center text-center">
          <img src={loginLogo} alt="Lucie" height="60" width="95" className="mb-4" />
          <CardTitle className="text-lg">{title}</CardTitle>
          {description && <CardDescription className="text-sm">{description}</CardDescription>}
        </CardHeader>
        <CardContent className={contentClassName}>{children}</CardContent>
      </Card>
    </div>
  )
}
